import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Box, Button, GlobalStyle, Link, Text } from '@acast-tech/decibel';
import React from 'react';

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ErrorBoundary)).call.apply(_getPrototypeOf2, [this, props].concat(rest)));
    _this.state = {
      hasError: false,
      hasRetryButton: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      var captureException = this.props.captureException;

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error(error);
      }

      captureException(error);
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var _this$props = this.props,
          supportEmail = _this$props.supportEmail,
          renderErrorMessage = _this$props.renderErrorMessage;
      var _this$state = this.state,
          error = _this$state.error,
          hasRetryButton = _this$state.hasRetryButton;

      if (renderErrorMessage) {
        var message = renderErrorMessage(error);

        if (message) {
          return message;
        }
      }

      return React.createElement(React.Fragment, null, React.createElement(Text, {
        variant: "h3",
        as: "h1"
      }, "Sorry, something went wrong on our side."), React.createElement(Text, null, "Please try again later or contact our", ' ', React.createElement(Link, {
        href: "mailto:".concat(supportEmail)
      }, "support team"), "."), hasRetryButton && React.createElement(Button, {
        href: window.location.origin
      }, "Try again"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          renderAppBar = _this$props2.renderAppBar;
      var hasError = this.state.hasError;

      if (hasError) {
        return React.createElement(React.Fragment, null, React.createElement(GlobalStyle, {
          appRootSelector: "#app-root"
        }), renderAppBar(), React.createElement(Box, {
          minHeight: "100vh",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }, this.getErrorMessage()));
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      var nextState = {
        hasError: true,
        error: error
      }; // Auth0 error

      if (error.error === 'invalid_token') {
        return Object.assign({}, nextState, {
          hasRetryButton: true
        });
      }

      return nextState;
    }
  }]);

  return ErrorBoundary;
}(React.Component);

export { ErrorBoundary as default };
ErrorBoundary.defaultProps = {
  renderErrorMessage: undefined
};